const apiEndPoint = process.env.REACT_APP_API_URL;



export { apiEndPoint }